import { createFileRoute } from '@tanstack/react-router'

import { validateConfiguratorSearch } from '@/components/Customer/Configurator/configurator-search'
import { ConfiguratorPage } from '@/components/Customer/Configurator/ConfiguratorPage'

export const Route = createFileRoute(
  '/internal/customer-view/$userId/project/$projectId/configure',
)({
  // Full-height, and the customer's own surface: no shell around it.
  staticData: { chrome: 'bare' },
  validateSearch: validateConfiguratorSearch,
  component: ConfiguratorPage,
})
